import restApi from './cmsApiService'

export default {
  getSites: async () => {
    try {
      const res = await restApi.get(`/sites`)
      return res.data
    } catch (err) {
      throw new Error(err)
    }
  },
  getSite: async site => {
    try {
      const res = await restApi.get(`/sites/${site}`)
      return res.data
    } catch (err) {
      throw new Error(err)
    }
  }
}
